<template>
  <v-btn @click.stop="onClick" text small>
    <span id="RTE__command__underline">U</span>
  </v-btn>
</template>

<script>
export default {
  name: 'underline',
  methods: {
    onClick () {
      this.$emit('click', 'underline')
    }
  }
}
</script>

<style scoped>
#RTE__command__underline {
  text-decoration: underline;
  font-size: 20px;
}
</style>
